import { SetStateAction, Dispatch } from 'react';

export enum DirectionButton {
  Prev = 'prev',
  Next = 'next',
}

export default interface PagesProps {
  callback: Dispatch<SetStateAction<number>>;
  numberOfPages: number;
  activePage: number;
  message?: string;
  truncateOver?: number;
}
